import { render, staticRenderFns } from "./SupplierBlock.vue?vue&type=template&id=3e229c31"
import script from "./SupplierBlock.vue?vue&type=script&lang=js"
export * from "./SupplierBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports